import Vue from 'vue';

import { store, getters } from '../store.js'
import {datesMixin} from './DatesMixin'

import * as dayjs from 'dayjs'

export const automationMixin = {
    mixins: [datesMixin],
    props: {
        automation: Object
    },
    data: function() {
        return {
            templates: [],
            usingTemplate: false,
            templateReference: "",
            showConditionOptions: [],
            addingCondition: false,
            newConditionType: "null",
            isShowNewConditionOptions: false,
            newConditionOperator: "equals",
            newConditionValue: "null",
            providerChannels: [],
            roomTypes: [],
            showEditDialog: false,
            showConfirmDeleteDialog: false,
            showConfirmDuplicateDialog: false,
            showConfirmToggleDialog: false,
            updating: false,
            deleted: false,
            error: false,
            infoMessage: "",
            showAgentTooltip: false
        }
    },
    computed: {
        isPMSEstablishment: function() {
            if (getters.getCurrentEstablishment().provider) {
                return true;
            }
            return false;
        },
        editingAutomation: function() {
            if (typeof this.automation.reference === 'undefined') {
                return false;
            }
            return true;
        },
        isSendOmniChannel: function() {
            switch (this.automation.type) {
                case 'send-omni-channel-guest-form':
                case 'upsell':
                    return true;
            }
            return false;
        },
        isOmniChannelGuestForm: function() {
            return this.automation.type === 'send-omni-channel-guest-form';
        },
        isForm: function() {
            switch (this.automation.type) {
                case 'send-omni-channel-guest-form':
                case 'guest-form':
                    return true;
            }
            return false;
        },
        isSendForm: function() {
            return this.automation.type === 'send-omni-channel-guest-form';
        },
        isSendEmail: function() {
            switch (this.automation.type) {
                case 'send-omni-channel-guest-form':
                case 'send-email':
                case 'upsell':
                    return true;
            }
            return false;
        },
        isSendSMS: function() {
            return this.automation.type === 'send-sms';
        },
        isSendSMSOrOmniChannelWithSMS : function() {
            switch (this.automation.type) {
                case 'send-omni-channel-guest-form':
                case 'send-sms':
                case 'upsell':
                    if (this.automation.sendSMS) {
                        return true;
                    }
            }
            return false;
        },
        isSendWhatsApp: function() {
            return this.automation.type === 'send-whatsapp';
        },
        isFrontDeskGuestForm: function() {
            return this.automation.type === 'guest-form';
        },
        isToDo: function() {
            return this.automation.type === 'to-do';
        },
        isUpsell: function() {
            return this.automation.type === 'upsell';
        },
        isWebhook: function() {
            return this.automation.type === 'webhook';
        },
        canSetCommunicationMode: function() {
            return !this.isNew && !this.isSendSMS && !this.isSendWhatsApp && !this.isFrontDeskGuestForm && !this.isToDo && !this.isWebhook;
        },
        isCommunicationSent: function() {
            return this.automation.communicationMode !== 'none';
        },
        isCommunicationHostOnly: function() {
            return this.automation.communicationMode === 'host-only';
        },
        isCommunicationBCCHost: function() {
            return this.automation.communicationMode === 'bcc-host';
        },
        isCommunicationGuestOnly: function() {
            return this.automation.communicationMode === 'guest-only';
        },
        isPauseNewTasks: function() {
            return this.automation.pauseNewTasks;
        },
        hasTemplates: function() {
            if (this.automation.type !== "") {
                const filteredTemplates =  this.templates.filter(t => t.type === this.automation.type);
                if (filteredTemplates.length > 0) {
                    return true;
                }
            }
            return false;
        },
        templateChoices: function() {
            return this.templates.filter(t => t.type === this.automation.type);
        },
        isNewConditionTypeChannel() {
            if (this.newConditionType === 'booking-source') {
                return true;
            }
            return false;
        },
        isNewConditionTypeAgent() {
            if (this.newConditionType === 'ota-booker') {
                return true;
            }
            return false;
        },
        hasAgentTrueCondition() {
            for (let condition of this.automation.conditions) {
                console.log(condition);
                if (this.isConditionTypeAgent(condition.type) &&
                    this.isConditionOperatorEqual(condition.operator) &&
                    condition.value === 'true') {
                    return true;
                }
            }
            return false;
        },
        sendingToGuestOrAgent: function() {
            if (this.hasAgentTrueCondition) {
                return "Agent"
            } else {
                return "Guest"
            }
        },
        confirmDeleteMessage: function() {
            return "Are you sure you want to <b>delete the automation '" + this.automation.name + "'</b>?";
        },
        confirmDuplicateMessage: function() {
            return "Would you like to <b>duplicate the automation '" + this.automation.name + "'</b>?";
        },
        automationTypeAsString: function() {
            switch (this.automation.type) {
                case 'send-email':
                    return "Send email";
                case 'send-sms':
                    return "Send SMS";
                case 'send-whatsapp':
                    return "Send WhatsApp";
                case 'send-omni-channel-guest-form':
                    return "Form";
                case 'pdf-form-response':
                    return "PDF a form response";
                case 'to-do':
                    return "Create To Do";
                case 'send-omni-channel':
                    return "Send Email and SMS";
                case 'guest-form':
                    return "Front desk Form";
                case 'upsell':
                    return "Upsell";
                case 'webhook':
                    return "Webhook";
            }
            return "";
        },
        when: function() {
            let result = Math.abs(this.automation.dayIncrement);
            if (this.automation.dayIncrement && Math.abs(this.automation.dayIncrement) === 1) {
                result += " day ";
            } else {
                result += " days ";
            }
            switch (this.automation.when.strategy) {
                case 'immediate':
                    return "Immediately";
                default:
                    if (this.automation.dayIncrement === 0) {
                        return "On day";
                    } else if (this.automation.dayIncrement < 0) {
                        return result + "before";
                    } else {
                        return result + "after";
                    }
            }
        },
        isSameDelayAsPreviousAutomation: function () {
            return this.previousAutomation && this.automation.dayIncrement === this.previousAutomation.dayIncrement;
        },
        isSameDelayAsNextAutomation: function () {
            return this.nextAutomation && this.automation.dayIncrement === this.nextAutomation.dayIncrement;
        },
    },
    methods: {
        setAutomationType: function(type) {
            this.automation.type = type;
            this.usingTemplate = false;
            this.templateReference = "";
            if (!this.isOmniChannelGuestForm) {
                this.automation.showBookingSummary = false;
                this.automation.showPricing = false;
            }
            if (this.isFrontDeskGuestForm) {
                this.automation.when.numberOfDaysFrom = 0;
            }
            if (this.isSendSMS) {
                this.automation.sendSMS = true;
            } else {
                this.automation.sendSMS = false;
            }
            if (this.isSendSMS || this.isSendWhatsApp) {
                this.automation.communicationMode = 'guest-only';
            } else {
                this.automation.communicationMode = 'host-only';
            }
        },
        setCommunicationMode: function(communicationMode) {
            this.automation.communicationMode = communicationMode;
        },
        fetchAutomationTemplates: function() {
            console.log("fetching templates for event automation");
            this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/automations/templates', {
                withCredentials: true
            }).then(response => {
                if (response.data) {
                    this.templates = response.data;
                    this.templates.forEach(t => t.displayName = t.name + ((t.systemTemplate === true)?" (System)":""));
                    this.templates.sort(function(a, b) {
                        if (a.systemTemplate === true & b.systemTemplate === false) {
                            return -1;
                        }
                        if (b.systemTemplate === true & a.systemTemplate === false) {
                            return 1;
                        }
                        return a.displayName.localeCompare(b.displayName, "en", { numeric: true });
                    });
                }
            }).catch(error => {
                console.log(error)
            }).finally(() => {
            })
        },
        setAppliesToAllBookings(appliesToAllBookings) {
            this.automation.appliesToAllBookings = appliesToAllBookings;
            if (!appliesToAllBookings && this.automation.conditions.length === 0) {
                this.addCondition();
            } else if (appliesToAllBookings) {
                this.automation.conditions.splice(0, this.automation.conditions.length);
            }
        },
        isConditionTypeChannel(type) {
            if (type === 'booking-source') {
                return true;
            }
            return false;
        },
        isConditionTypeAgent(type) {
            if (type === 'ota-booker') {
                return true;
            }
            return false;
        },
        isConditionOperatorEqual(operator) {
            return operator === 'equals';
        },
        isConditionOperatorNotEqual(operator) {
            return operator === 'not-equals';
        },
        isConditionOperatorLessThan(operator) {
            return operator === 'less-than';
        },
        isConditionOperatorGreaterThan(operator) {
            return operator === 'greater-than';
        },
        toggleConditionOptions: function(condition, index) {
            if (!this.isConditionTypeAgent(condition)) {
                Vue.set(this.showConditionOptions, index, !this.showConditionOptions[index])
            }
        },
        hideAllConditionOptions: function() {
            for (let index = 0; index < this.showConditionOptions.length; index++) {
                Vue.set(this.showConditionOptions, index, false);
            }
        },
        isShowConditionOptions: function(index) {
            return this.showConditionOptions[index];
        },
        conditionTypeChanged: function(condition) {
            switch (condition.type) {
                case 'booking-date':
                    condition.operator = "greater-than";
                    condition.value = dayjs().toDate();
                    break;
                case 'booking-source':
                case 'ota-booker':
                case 'family-booking':
                case 'length-of-stay':
                case 'room-type':
                default:
                    condition.operator = "equals";
                    condition.value = null;
            }
        },
        selectConditionOperator: function(index, operator) {
            this.automation.conditions[index].operator = operator;
            Vue.set(this.showConditionOptions, index, false);
        },
        allowEqualsOperator: function(type) {
            switch (type) {
                case 'booking-source':
                case 'ota-booker':
                case 'family-booking':
                case 'length-of-stay':
                case 'room-type':
                    return true;
                case 'booking-date':
                default:
                    return false;
            }
        },
        allowNotEqualsOperator: function(type) {
            switch (type) {
                case 'booking-source':
                case 'family-booking':
                case 'length-of-stay':
                case 'room-type':
                    return true;
                case 'ota-booker':
                case 'booking-date':
                default:
                    return false;
            }
        },
        allowLessThanOperator: function(type) {
            switch (type) {
                case 'booking-source':
                case 'ota-booker':
                case 'family-booking':
                case 'length-of-stay':
                case 'room-type':
                    return false;
                case 'booking-date':
                default:
                    return true;
            }
        },
        allowGreaterThanOperator: function(type) {
            switch (type) {
                case 'booking-source':
                case 'ota-booker':
                case 'family-booking':
                case 'length-of-stay':
                case 'room-type':
                    return false;
                case 'booking-date':
                default:
                    return true;
            }
        },
        isConditionValueMultipleChoice: function(type) {
            switch (type) {
                case 'length-of-stay':
                case 'booking-date':
                    return false;
                case 'booking-source':
                case 'ota-booker':
                case 'family-booking':
                case 'room-type':
                default:
                    return true;
            }
        },
        conditionValueOptions: function(type) {
            let options = [];
            switch (type) {
                case 'booking-source':
                    for (let providerChannel of this.providerChannels) {
                        if (providerChannel.showStandalone) {
                            options.push({'label': providerChannel.providerChannelName, 'value': providerChannel.providerChannelId});
                        }
                    }
                    return options;
                case 'room-type':
                    for (let roomType of this.roomTypes) {
                        options.push({'label': roomType.name, 'value': roomType.reference});
                    }
                    return options;
                case 'ota-booker':
                case 'family-booking':
                    return [{'label': 'True', 'value': 'true'}, {'label': 'False', 'value': 'false'}];
                case 'length-of-stay':
                case 'booking-date':
                default:
                    return options;
            }
        },
        isConditionValueDate: function(type) {
            switch (type) {
                case 'booking-date':
                    return true;
                case 'booking-source':
                case 'ota-booker':
                case 'family-booking':
                case 'length-of-stay':
                case 'room-type':
                default:
                    return false;
            }
        },
        parseDate: function (dateString, format) {
            return dayjs(dateString, format).toDate();
        },
        formatDate: function (date, format) {
            return dayjs(date).format(format);
        },
        openDateComponent: function () {
            this.$refs.dateComponent.open();
        },
        showAddCondition: function() {
            this.addingCondition = true;
            setTimeout(() => {
                this.$refs.addConditionType.focus();
            }, 500)
        },
        toggleNewConditionOptions: function() {
            this.isShowNewConditionOptions = !this.isShowNewConditionOptions;
        },
        hideNewConditionOptions: function() {
            if (this.isShowNewConditionOptions) {
                this.isShowNewConditionOptions = false;
            }
        },
        selectNewConditionOperator: function(operator) {
            this.newConditionOperator = operator;
            this.isShowNewConditionOptions = false;
        },
        addCondition: function() {
            this.automation.conditions.push({type: this.newConditionType, operator: this.newConditionOperator, value: this.newConditionValue});
            this.newConditionType = "null";
            this.newConditionOperator = "equals";
            this.newConditionValue = "null";
            this.showConditionOptions.push(false);
            this.addingCondition = false;
        },
        cancelAdd: function() {
            this.addingCondition = false;
        },
        deleteCondition: function(index) {
            console.log("Removing " + index);
            this.automation.conditions.splice(index,1);
            if (this.automation.conditions.length === 0) {
                this.automation.appliesToAllBookings = true;
            }
        },
        conditionTypeAsString: function(condition) {
            switch (condition.type) {
                case 'booking-source':
                    return 'Channel'
                case 'ota-booker':
                    return 'Agent email'
                case 'family-booking':
                    return 'Family'
                case 'length-of-stay':
                    return 'Length of stay'
                case 'booking-date':
                    return 'Booked'
                case 'room-type':
                    return 'Room Type'
            }
            return "";
        },
        conditionOperatorAsIcon: function(condition) {
            switch (condition.operator) {
                case 'equals':
                    return '<i class="fas fa-equals"></i>'
                case 'not-equals':
                    return '<i class="fas fa-not-equal"></i>'
                case 'less-than':
                    return '<i class="fas fa-less-than"></i>'
                case 'greater-than':
                    return '<i class="fas fa-greater-than"></i>'
            }
            return "";
        },
        conditionValueAsString: function(condition) {
            let providerChannels;
            let roomTypes;
            switch (condition.type) {
                case 'booking-source':
                    providerChannels = store.currentEstablishmentProviderChannels;
                    for (let channel of providerChannels) {
                        if (condition.value === channel.providerChannelId) {
                            return channel.providerChannelName;
                        }
                    }
                    break;
                case 'room-type':
                    roomTypes = getters.getCurrentEstablishment().roomTypes;
                    for (let roomType of roomTypes) {
                        if (condition.value === roomType.reference) {
                            return roomType.name;
                        }
                    }
                    break;
                case 'booking-date':
                    return this.friendlyDateAndTime(condition.value);
            }
            return condition.value;
        },
        openFormTemplate: function () {
            this.$router.push({ name: 'EditFormTemplate', params: { reference: this.automation.formTemplateReference } })
        },
        openEmailTemplate: function () {
            if (this.isForm) {
                this.$router.push({
                    name: 'EditEmailTemplate',
                    params: {reference: this.automation.emailTemplateReference},
                    query: {requiredVariables: "formURL"}
                })
            } else {
                this.$router.push({
                    name: 'EditEmailTemplate',
                    params: {reference: this.automation.emailTemplateReference}
                })
            }
        },
        openSMSTemplate: function () {
            if (this.isForm) {
                this.$router.push({
                    name: 'EditSMSTemplate',
                    params: {reference: this.automation.smsTemplateReference},
                    query: {requiredVariables: "formURL"}
                })
            } else {
                this.$router.push({
                    name: 'EditSMSTemplate',
                    params: {reference: this.automation.smsTemplateReference}
                })
            }
        },
        openWhatsAppTemplate: function () {
            this.$router.push({
                name: 'SelectWhatsAppTemplate',
                params: {reference: this.automation.reference}
            })
        },
        openWebhook: function() {
            this.$router.push({
                name: 'EditWebhook',
                params: {reference: this.automation.webhookReference}
            })
        },
        editAutomation: function() {
            console.log("Editing automation");
            this.showEditDialog = true;
            console.log('showing edit modal');
        },
        stopEditingAutomation: function() {
            this.showEditDialog = false;
        },
        confirmDuplicateAutomation: function() {
            console.log("Duplicating automation");
            this.showConfirmDuplicateDialog = true;
        },
        duplicateAutomation: function(uid, establishmentReference) {
            this.showConfirmDuplicateDialog = false;
            if (this._uid === parseInt(uid)) {
                console.log("Duplicate automation: " + uid + " for establishment: " + establishmentReference);
                this.infoMessage = "Duplicating automation";
                this.updating = true;
                this.$http.post('/guest-management/v1/establishments/' + store.currentEstablishmentReference
                    + '/automations/' + this.automation.reference + '/duplicate' + (establishmentReference ? "?toEstablishmentReference=" + establishmentReference : "")
                ).then(response => {
                    console.log("Automation duplicated:")
                    console.log(response);
                    this.infoMessage = "Automation successfully duplicated";
                    setTimeout(() => {
                        this.updating = false;
                        if (establishmentReference === store.currentEstablishmentReference) {
                            this.$root.$emit('finished-editing-automation', response.data);
                        } else {
                            this.$root.$emit('finished-editing-automation');
                        }
                    }, 2000);
                }).catch(error => {
                    this.updating = false;
                    this.error = true;
                    if (error.response) {
                        this.infoMessage = "Error: " + error.response.data.message;
                    } else {
                        this.infoMessage = "Error duplicating automation";
                    }
                    setTimeout(() => {
                        this.error = false;
                    }, 5000);
                });
            }
        },
        confirmDeleteAction: function() {
            this.showConfirmDeleteDialog = true;
        },
        deleteAutomation: function(uid) {
            this.showConfirmDeleteDialog = false;
            if (this._uid === parseInt(uid)) {
                console.log("Deleting automation");
                this.infoMessage = "Deleting automation";
                this.updating = true;
                this.$http.delete('/guest-management/v1/establishments/' + store.currentEstablishmentReference
                    + '/automations/' + this.automation.reference
                ).then(response => {
                    console.log("Automation deleted:")
                    console.log(response);
                    this.infoMessage = "Automation successfully deleted";
                    this.deleted = true;
                    setTimeout(() => {
                        this.updating = false;
                        this.$root.$emit('deleted-automation', this.automation.reference);
                    }, 2000);
                }).catch(error => {
                    this.updating = false;
                    this.error = true;
                    if (error.response) {
                        this.infoMessage = "Error: " + error.response.data.message;
                    } else {
                        this.infoMessage = "Error deleting automation";
                    }
                    setTimeout(() => {
                        this.error = false;
                    }, 5000);
                });
            }
        },
        confirmToggleAutomation: function() {
            this.showConfirmToggleDialog = true;
        },
        toggleTimedAutomation: async function(uid, turnOn, createMissingTasks, bookingRefsToCreateTasksFor, pauseTasks, bookingRefsToPauseTasksFor, unPauseTasks, bookingRefsToUnPauseTasksFor) {
            this.showConfirmToggleDialog = false;
            if (this._uid !== parseInt(uid)) {
                return;
            }

            this.automation.active = turnOn;
            let body = {
                "reference": this.automation.reference,
                "turnOn": turnOn,
                "pauseTasks": pauseTasks,
                "unPauseTasks": unPauseTasks,
                "createMissingTasks": createMissingTasks,
            };
            if (bookingRefsToCreateTasksFor) {
                body.bookingRefsToCreateTasksFor = bookingRefsToCreateTasksFor;
            }
            if (bookingRefsToPauseTasksFor) {
                body.bookingRefsToPauseTasksFor = bookingRefsToPauseTasksFor;
            }
            if (bookingRefsToUnPauseTasksFor) {
                body.bookingRefsToUnPauseTasksFor = bookingRefsToUnPauseTasksFor;
            }
            console.log(body);

            let url = '/guest-management/v1/establishments/' + store.currentEstablishmentReference
                + '/automations/' + this.automation.reference + "/toggle";

            this.infoMessage = "Turning automation " + ((turnOn) ? "on" : "off");
            this.updating = true;

            try {
                await this.$http.put(url, body);
                console.log("Automation toggled");
                this.automation.active = turnOn;
                this.infoMessage = "Automation turned " + ((this.automation.active) ? "on" : "off");
                setTimeout(() => {
                    this.updating = false;
                }, 2000);
            } catch (error) {
                this.error = true;
                this.updating = false;
                if (error.response) {
                    this.infoMessage = "Error: " + error.response.data.message
                } else {
                    this.infoMessage = "Error turning automation " + ((this.automation.active) ? "on" : "off");
                }
                this.automation.active = !this.automation.active;
            }
        }
    },
    mounted() {
        this.$root.$on('finished-editing-automation', this.stopEditingAutomation);
        this.$root.$on('duplicate-automation', this.duplicateAutomation);
        this.$root.$on('delete-automation', this.deleteAutomation);
        this.$root.$on('toggle-timed-automation', this.toggleTimedAutomation);
    },
    beforeDestroy () {
        this.$root.$off('finished-editing-automation', this.stopEditingAutomation);
        this.$root.$off('duplicate-automation', this.duplicateAutomation);
        this.$root.$off('delete-automation', this.deleteAutomation);
        this.$root.$off('toggle-timed-automation', this.toggleTimedAutomation);
    }
}